/** @format */

import { HmfPrices } from '@dsg-tech/homefield-angular';

/**
 * Default empty HmfPrices object with all properties set to empty strings
 * Used as fallback when price data is null, undefined, or when specific properties are missing
 */
export const EMPTY_HMF_PRICES: HmfPrices = {
  maxListPrice: '',
  maxOfferPrice: '',
  minListPrice: '',
  minOfferPrice: '',
  maxMapPrice: '',
  offerPrice: '',
};
